import React from 'react';
import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import { MusicEventBlock } from './MusicEventBlock';
import type { DetailsProps } from './types';

export const DetailsWithoutImage = ({
    hideStartDate,
    isSeriesParent,
    startDateTime,
    startMonthAbbr,
    startDay,
    hasArtistPresentedByModule,
    hasPresenterOrAgeRestriction,
    eventName,
    eventNameTruncated,
    displayOrganizationName,
    shouldDisplayRsvp,
    displayPrice,
    shouldShowExternalTicketingProvider,
    externalTicketingProviderLabelText,
    orgProfileLink,
    organizationNameTruncated,
    hasPresenter,
    presenter,
    hasAgeRestriction,
    ageRestriction,
    shouldShowPriceOnHero,
}: DetailsProps) => {
    return (
        <div className="g-group l-md-pad-hor-3">
            <div className="g-cell-1-1 g-cell-lg-10-12 g-offset-lg-1-12 l-pad-vert-1 l-md-pad-top-4 l-md-pad-bot-2">
                <div className="g-group l-pad-top-6 l-pad-bot-4 l-sm-pad-hor-4">
                    <div className="g-cell g-cell-1-1 g-cell-md-8-12">
                        <div className="g-group">
                            <div
                                className={`g-cell g-cell--no-gutters g-cell-1-1 g-cell-md-2-12 g-cell-lg-1-1 hide-small ${
                                    isSeriesParent ? 'hide-medium' : ''
                                }`}
                            >
                                {!hideStartDate && (
                                    <Header
                                        hasCroppedLogo={false}
                                        isSeriesParent={isSeriesParent}
                                        startDateTime={startDateTime}
                                        startMonthAbbr={startMonthAbbr}
                                        startDay={startDay}
                                    />
                                )}
                            </div>
                            <div className="g-cell g-cell--no-gutters g-cell-1-1 g-cell-md-10-12 g-cell-lg-1-1">
                                <Body
                                    hasCroppedLogo={false}
                                    isSeriesParent={isSeriesParent}
                                    startDateTime={startDateTime}
                                    startMonthAbbr={startMonthAbbr}
                                    hasArtistPresentedByModule={
                                        hasArtistPresentedByModule
                                    }
                                    hasPresenterOrAgeRestriction={
                                        hasPresenterOrAgeRestriction
                                    }
                                    eventName={eventName}
                                    eventNameTruncated={eventNameTruncated}
                                    displayOrganizationName={
                                        displayOrganizationName
                                    }
                                    orgProfileLink={orgProfileLink}
                                    organizationNameTruncated={
                                        organizationNameTruncated
                                    }
                                    hasPresenter={hasPresenter}
                                    presenter={presenter}
                                    hasAgeRestriction={hasAgeRestriction}
                                    ageRestriction={ageRestriction}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="g-cell g-cell-4-12 l-pad-left-6">
                        {hasPresenterOrAgeRestriction && (
                            <div className="has-user-generated-content listing-hero--no-image__justify-content hide-small">
                                <div className="l-pad-left-4 structured-content__module">
                                    <MusicEventBlock
                                        eventNameTruncated={eventNameTruncated}
                                        hasPresenter={hasPresenter}
                                        presenter={presenter}
                                        hasAgeRestriction={hasAgeRestriction}
                                        ageRestriction={ageRestriction}
                                    />
                                </div>
                            </div>
                        )}

                        {shouldShowPriceOnHero && (
                            <Footer
                                hasCroppedLogo={false}
                                displayPrice={displayPrice}
                                shouldDisplayRsvp={shouldDisplayRsvp}
                                shouldShowExternalTicketingProvider={
                                    shouldShowExternalTicketingProvider
                                }
                                externalTicketingProviderLabelText={
                                    externalTicketingProviderLabelText
                                }
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
